import { useNavigate, useParams } from 'react-router-dom';
import { Card, CardBody, CardHeader } from '@/components/card';
import { ClientForm } from './client-form';
import { useClient, useUpdateClient } from '@/lib/clients';

export function EditClient() {
  const { id } = useParams<{ id: string }>();
  const clientId = id ? Number(id) : undefined;
  const navigate = useNavigate();
  const { data: client, isLoading } = useClient(clientId);
  const update = useUpdateClient(clientId ?? 0);

  if (isLoading || !client) {
    return <p className="text-sm text-[var(--color-foreground-muted)]">Loading…</p>;
  }

  return (
    <div className="mx-auto max-w-3xl space-y-5">
      <h1 className="text-2xl font-semibold tracking-tight">Edit {client.name}</h1>
      <Card>
        <CardHeader>
          <p className="text-sm text-[var(--color-foreground-muted)]">
            Changes are tracked in this client's activity log.
          </p>
        </CardHeader>
        <CardBody>
          <ClientForm
            initial={client}
            onSubmit={async (input) => {
              await update.mutateAsync(input);
              navigate(`/clients/${client.id}`);
            }}
            submitLabel="Save changes"
          />
        </CardBody>
      </Card>
    </div>
  );
}
